import type { DiagramSpec } from "../types"

/** Matrix grid — pipelines × capabilities with manual positioning */
export const matrixDiagram: DiagramSpec = {
  id: "matrix",
  name: "Matrix: Pipeline × Tool Coverage",
  description: "Grid showing which tools each pipeline uses",
  layers: [
    { id: "header", name: "Header", color: "#64748b" },
    { id: "script", name: "Script", color: "#6366f1" },
    { id: "voice", name: "Voice", color: "#ec4899" },
    { id: "video", name: "Video", color: "#10b981" },
    { id: "edit", name: "Edit", color: "#f59e0b" },
  ],
  nodes: [
    // Column headers (rank 0)
    { id: "h-script", label: "Script", layer: "header", rank: 0, position: { x: 240, y: 0 }, type: "COLUMN" },
    { id: "h-voice", label: "Voice", layer: "header", rank: 0, position: { x: 480, y: 0 }, type: "COLUMN" },
    { id: "h-video", label: "Video Gen", layer: "header", rank: 0, position: { x: 720, y: 0 }, type: "COLUMN" },
    { id: "h-edit", label: "Auto-Edit", layer: "header", rank: 0, position: { x: 960, y: 0 }, type: "COLUMN" },

    // Row headers
    { id: "r-th", label: "Talking Head", layer: "header", rank: 1, position: { x: 0, y: 120 }, type: "ROW" },
    { id: "r-an", label: "Animation", layer: "header", rank: 2, position: { x: 0, y: 240 }, type: "ROW" },
    { id: "r-sl", label: "Slideshow", layer: "header", rank: 3, position: { x: 0, y: 360 }, type: "ROW" },
    { id: "r-sh", label: "Shorts", layer: "header", rank: 4, position: { x: 0, y: 480 }, type: "ROW" },

    // Grid cells — Talking Head
    { id: "th-s", label: "Claude", layer: "script", rank: 1, position: { x: 240, y: 120 } },
    { id: "th-v", label: "ElevenLabs", layer: "voice", rank: 1, position: { x: 480, y: 120 } },
    { id: "th-g", label: "Seedance", layer: "video", rank: 1, position: { x: 720, y: 120 } },
    { id: "th-e", label: "NanoBanana", layer: "edit", rank: 1, position: { x: 960, y: 120 } },

    // Grid cells — Animation
    { id: "an-s", label: "Claude", layer: "script", rank: 2, position: { x: 240, y: 240 } },
    { id: "an-g", label: "Veo 3", layer: "video", rank: 2, position: { x: 720, y: 240 } },
    { id: "an-e", label: "NanoBanana", layer: "edit", rank: 2, position: { x: 960, y: 240 } },

    // Grid cells — Slideshow
    { id: "sl-s", label: "Claude", layer: "script", rank: 3, position: { x: 240, y: 360 } },
    { id: "sl-v", label: "ElevenLabs", layer: "voice", rank: 3, position: { x: 480, y: 360 } },
    { id: "sl-e", label: "NanoBanana", layer: "edit", rank: 3, position: { x: 960, y: 360 } },

    // Grid cells — Shorts
    { id: "sh-s", label: "Claude", layer: "script", rank: 4, position: { x: 240, y: 480 } },
    { id: "sh-g", label: "Runway", layer: "video", rank: 4, position: { x: 720, y: 480 } },
    { id: "sh-e", label: "NanoBanana", layer: "edit", rank: 4, position: { x: 960, y: 480 } },
  ],
  edges: [
    // Talking Head flow
    { id: "e-th1", source: "th-s", target: "th-v" },
    { id: "e-th2", source: "th-v", target: "th-g" },
    { id: "e-th3", source: "th-g", target: "th-e" },
    // Animation flow
    { id: "e-an1", source: "an-s", target: "an-g" },
    { id: "e-an2", source: "an-g", target: "an-e" },
    // Slideshow flow
    { id: "e-sl1", source: "sl-s", target: "sl-v" },
    { id: "e-sl2", source: "sl-v", target: "sl-e" },
    // Shorts flow
    { id: "e-sh1", source: "sh-s", target: "sh-g" },
    { id: "e-sh2", source: "sh-g", target: "sh-e" },
  ],
  views: [{ id: "main", name: "Matrix", layout: "manual" }],
  defaultView: "main",
  preferences: {
    nodeWidth: 180,
    showLayerBands: false,
    edgeStyle: "straight",
    edgeColor: "#4a6a8a",
  },
}
